import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import classNames from "classnames";
import { StyledProps } from "@mui/styles/styled";
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import {
  IconButton,
  Toolbar
} from "@mui/material";

import {
  Menu as MenuIcon,
  Close as CloseIcon
} from "@mui/icons-material";

import { palette } from "../theme/cranecastTheme";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderBottom: `1px solid ${palette.grey[200]}`,
    backgroundColor: palette.background.default,
    display: "flex",
    alignItems: "center",
    height: "56px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
  },
  toolbar: {
    minHeight: "56px",
    width: "100%",
    display: "flex",
    padding: "0 16px",
  },
  menuButton: {
    color: palette.text.primary,
    "&:hover": {
      backgroundColor: palette.grey[100],
    }
  }
}));

interface Props extends RouteComponentProps, StyledProps {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
}

const Topbar = ({ className, isSidebarOpen, onToggleSidebar }: Props) => {
  const classes = useStyles();

  return (
    <AppBar 
      position="fixed"
      sx={{
        backgroundColor: palette.background.default,
        color: palette.text.primary,
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div className={classNames(classes.root, className)}>
        <Toolbar className={classes.toolbar}>
          <IconButton className={classes.menuButton} onClick={onToggleSidebar} size="large">
            {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
          </IconButton>
        </Toolbar>
      </div>
    </AppBar>
  );
};

export default withRouter(Topbar);
